import PropTypes from 'prop-types';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useState } from 'react';
import { Divider } from '@material-ui/core';
import { useSelector } from 'react-redux';
import MarkdownToHtml from '../../../../MarkdownToHtml';

const HotelDeals = ({ deals }) => {
  const [expandedDeals, setExpandedDeals] = useState({});

  const handleViewRatesClick = (dealId) => {
    setExpandedDeals((prevExpandedDeals) => {
      const isDealExpanded = prevExpandedDeals[dealId];
      return { ...prevExpandedDeals, [dealId]: !isDealExpanded };
    });
  };
  const { travelAgency } = useSelector((store) => store.user);
  const hotelTabTitle =
    travelAgency && travelAgency.filterSettings && travelAgency.filterSettings.hotelDealsTabTitle;

  return deals && deals.length > 0 ? (
    deals.map((deal) => (
      <div key={deal.id} className="mb-4 border rounded p-4">
        <div
          className="flex justify-between items-center"
          role="button"
          tabIndex="-1"
          onKeyDown={() => {}}
          onClick={() => handleViewRatesClick(deal.id)}
        >
          <div className="title">{deal.name}</div>
          <div className="text-base text-theme cursor-pointer z-10 flex items-center">
            {expandedDeals[deal.id] ? (
              <>
                Hide Deals
                <FaChevronUp className="pl-1" />
              </>
            ) : (
              <>
                View Deals
                <FaChevronDown className="pl-1" />
              </>
            )}
          </div>
        </div>
        {expandedDeals[deal.id] && (
          <div className="mt-2">
            <Divider />
            <MarkdownToHtml content={deal.description} className="mt-2" />
          </div>
        )}
      </div>
    ))
  ) : (
    <div className="m-3 italic">No {hotelTabTitle || 'deals'} found for the hotel</div>
  );
};

HotelDeals.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.shape({})),
};

HotelDeals.defaultProps = {
  deals: [],
};

export default HotelDeals;
